var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    fill: "#FFFFFF",
    width: 512,
    height: 341.337
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    fill: "#0052B4",
    width: 170.663,
    height: 341.337
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 341.337,
    y: 85.331,
    fill: "#D80027",
    width: 170.663,
    height: 341.337
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.b6b1e81f844762a2caaaef00c6a491b3.svg";
export { ForwardRef as ReactComponent };